import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/api/apiSlice";
import authReducer from "../features/auth/authSlice";
import alertsReducer from "../features/alerts/alertsSlice";
import modalReducer from "./modalSlice";
import trainPostsReducer from "../features/features/trainPostsSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    alerts: alertsReducer,
    modal: modalReducer,
    trainPosts: trainPostsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: process.env.NODE_ENV === "development",
});
